import { MENU_CONTROL_FOCUSABLE_SELECTOR, MENU_CONTROL_SELECTED_SELECTOR } from "./menu.constants";

/**
 * Finds what should take focus when the keyboard reaches a control row: the control's selected option, or else the
 * first part of it that can take focus.
 * @param row The control row.
 * @returns The element to focus, or null when the control can't take focus.
 */
export const getControlFocusTarget = (row: HTMLElement) =>
    row.querySelector<HTMLElement>(MENU_CONTROL_SELECTED_SELECTOR) ??
    row.querySelector<HTMLElement>(MENU_CONTROL_FOCUSABLE_SELECTOR);
